import React, { Fragment, useEffect, useState } from 'react'

import { ListingSkeletonBone } from '@vividseats/vivid-ui-kit'

export interface UseListingSkeletonProps {
    isLoading: boolean
    hideAfterMilliSeconds?: number // milliseconds

    fallbackComponent?: React.FC<any>
}

export const useListingSkeletonBone = ({
    isLoading,
    hideAfterMilliSeconds, // milliseconds
    fallbackComponent = Fragment, // The default fallback component is an empty fragment
}: UseListingSkeletonProps): React.FC => {
    const [hideSkeleton, setHideSkeleton] = useState(false)

    useEffect(() => {
        if (!isLoading) {
            setHideSkeleton(true)
        }
    }, [isLoading])

    if (Number(hideAfterMilliSeconds) > 0)
        setTimeout(() => {
            setHideSkeleton(true)
        }, hideAfterMilliSeconds)

    return hideSkeleton ? fallbackComponent : ListingSkeletonBone
}
